export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";